
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stay-experience-details/[slug]",
      function () {
        return require("private-next-pages/stay-experience-details/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stay-experience-details/[slug]"])
      });
    }
  